import { Routes, Route } from 'react-router-dom';
import { LayoutDashboard, Receipt, FileSpreadsheet, FileUp, Bell } from 'lucide-react';
import PortalLayout, { type NavItem } from '../../components/PortalLayout';

import Dashboard from './Dashboard';
import Expenses from './Expenses';
import MonthlyExpenses from './MonthlyExpenses';
import ExpenseReports from './ExpenseReports';
import AccountReports from './AccountReports';
import NoticeBoard from '../Admin/NoticeBoard';
import Profile from '../../components/Profile';

const navItems: NavItem[] = [
  { to: '/accounts', label: 'Dashboard', icon: <LayoutDashboard className="h-5 w-5" />, end: true },
  { to: '/accounts/expenses', label: 'Expense Review', icon: <Receipt className="h-5 w-5" /> },
  { to: '/accounts/monthly-expenses', label: 'Monthly Expenses', icon: <FileSpreadsheet className="h-5 w-5" /> },
  { to: '/accounts/expense-reports', label: 'Expense Reports', icon: <FileUp className="h-5 w-5" /> },
  { to: '/accounts/account-reports', label: 'Account Reports', icon: <FileUp className="h-5 w-5" /> },
  { to: '/accounts/notices', label: 'Notices', icon: <Bell className="h-5 w-5" /> },
];

export default function Account() {
  return (
    <PortalLayout title="Account Portal" navItems={navItems}>
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="monthly-expenses" element={<MonthlyExpenses />} />
        <Route path="expense-reports" element={<ExpenseReports />} />
        <Route path="account-reports" element={<AccountReports />} />
        <Route path="notices" element={<NoticeBoard />} />
        <Route path="profile" element={<Profile />} />
      </Routes>
    </PortalLayout>
  );
}
